import styles from './ViewTourInfo.module.css';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

const ViewTourInfo = (props) => {
    
    const { show, handleClose, tourInfo } = props;
    
    if (!show) return null;
    
    return (
        <div className={styles.viewTourInfo}>
            {/* <div className={styles.closeBtn} onClick={handleClose}>
                <Button variant="warning" block size="lg">Start Tour</Button>
            </div> */}
            <Container>
                <div className={styles.tourTitleHeader}>
                    <h1>
                        { tourInfo.tourName }
                    </h1>
                    <div className={styles.closeBtn} onClick={handleClose}>
                        <Button variant="warning" block size="lg">Start Tour</Button>
                    </div>
                </div>
                <p>
                    { tourInfo.tourDescription }
                </p>
                <div className={styles.tourPoster}>
                    <img src={tourInfo.tourPoster.url} alt="tour-poster"/>
                </div>
            </Container>
        </div>
    );
};

export default ViewTourInfo;